document.addEventListener('DOMContentLoaded', function () {

  // ======================
  // Swiper 初始化工具函式
  // ======================

  function initSwiper(selector, optionsCallback) {
    document.querySelectorAll(selector).forEach(el => {
      if (!el.swiper) {
        new Swiper(el, optionsCallback(el));
      }
    });
  }

  if (typeof Swiper !== 'undefined') {
    initSwiper('.auto-swiper', el => ({
      loop: true,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
    }));

    initSwiper('.manual-swiper', el => ({
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
    }));

    initSwiper('.fade-swiper', () => ({
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
    }));

    initSwiper('.product-rec-swiper', el => {
      const slidesPerView = parseInt(el.dataset.slides) || 1;
      const spaceBetween = parseInt(el.dataset.spacing) || 0;

      return {
        slidesPerView,
        spaceBetween,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          992: { slidesPerView },
        },
      };
    });

    initSwiper('.featured-video-swiper', el => {
      const slidesPerView = parseInt(el.dataset.slides) || 1;
      const spaceBetween = parseInt(el.dataset.spacing) || 0;

      return {
        effect: 'coverflow',
        slidesPerView,
        spaceBetween,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          992: { slidesPerView },
        },
      };
    });
  } else {
    console.warn('Swiper 尚未載入！');
  }


  // =====================
  // AOS 初始化
  // =====================

  if (window.AOS && typeof AOS.init === 'function') {
    AOS.init({
      startEvent: 'load',
      once: false,
    });
  } else {
    console.warn('AOS.js 尚未載入！');
  }


  // ====================
  // 返回頂部按鈕
  // ====================

  const topButton = document.getElementById("LH-toTop-btn");
  if (topButton) {
    window.addEventListener('scroll', () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      topButton.style.display = scrollTop > 20 ? "block" : "none";
    }, { passive: true });

    topButton.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }


  // ====================
  // 密碼顯示切換
  // ====================

  const passwordGroups = document.querySelectorAll('.password-group');

  if (passwordGroups.length > 0) {
    passwordGroups.forEach(group => {
      const input = group.querySelector('.togglePW-act');
      const toggle = group.querySelector('.togglePassword');
      const icon = group.querySelector('.eyeIcon');

      if (input && toggle && icon) {
        toggle.addEventListener('click', () => {
          const isPwd = input.type === 'password';
          input.type = isPwd ? 'text' : 'password';
          icon.classList.toggle('bi-eye-fill', isPwd);
          icon.classList.toggle('bi-eye-slash-fill', !isPwd);
        });
      }
    });
  }


  // ====================
  // 日期選擇器
  // ====================

  (function () {
    const dateInput = document.querySelector('#dateInput');
    if (!dateInput) return;
    if (typeof flatpickr !== 'function') {
      console.warn('flatpickr 尚未載入！');
      return;
    }

    flatpickr(dateInput, {
      dateFormat: 'Y-m-d',
    });
  })();


  // ====================
  // 商品圖庫切換
  // ====================

  (function () {
    const galleries = document.querySelectorAll('.product-gallery');
    if (!galleries.length) return;

    galleries.forEach(gallery => {
      const mainImg = gallery.querySelector('.productMain-img');
      const mainLink = gallery.querySelector('.glightbox');
      const thumbs = gallery.querySelectorAll('.thumb');

      if (!mainImg || !mainLink || !thumbs.length) return;

      // 切換主圖
      gallery.addEventListener('mouseover', e => {
        const thumb = e.target.closest('.thumb');
        if (!thumb) return;

        const newSrc = thumb.dataset.large || thumb.src;
        mainImg.src = newSrc;
        mainLink.href = newSrc;

        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });

      // 點擊主圖開啟 lightbox
      mainLink.addEventListener('click', e => {
        e.preventDefault();

        const lightbox = GLightbox({
          elements: [{ href: mainLink.href, type: 'image' }],
        });

        lightbox.open();
        lightbox.on('close', () => lightbox.destroy());
      });
    });
  })();


  // ====================
  // 商品數量加減
  // ====================

  (function () {
    const min = 1;
    const max = 99;

    const sanitizeValue = value => {
      const num = parseInt(value, 10);
      return isNaN(num) ? min : Math.min(Math.max(num, min), max);
    };

    const quantityGroups = document.querySelectorAll('.quantity-group');
    if (!quantityGroups.length) return;

    quantityGroups.forEach(group => {
      const input = group.querySelector('.quantity-input');
      const addBtn = group.querySelector('.add-btn');
      const subBtn = group.querySelector('.subtract-btn');

      if (!input) return;

      // 加一
      addBtn?.addEventListener('click', () => {
        const value = sanitizeValue(input.value);
        if (value < max) input.value = value + 1;
      });

      // 減一
      subBtn?.addEventListener('click', () => {
        const value = sanitizeValue(input.value);
        if (value > min) input.value = value - 1;
      });

      // 即時輸入校正
      input.addEventListener('input', () => {
        input.value = sanitizeValue(input.value);
      });

      // 離開輸入框時再校正一次
      input.addEventListener('blur', () => {
        input.value = sanitizeValue(input.value);
      });
    });
  })();


  // ====================
  // GLightbox 初始化工具
  // ====================

  (function () {
    // 初始化 GLightbox（可選觸發 callback）
    function initLightbox(selector, onOpen = null) {
      if (!document.querySelector(selector)) return;

      GLightbox({
        selector,
        touchNavigation: false,
        openEffect: 'zoom',
        closeEffect: 'zoom',
        closeButton: true,
        slideButtons: false,
        keyboardNavigation: false,
        loop: false,
        onOpen: (instance) => {
          document.querySelectorAll('.gprev, .gnext').forEach(btn => btn.remove());
          if (typeof onOpen === 'function') onOpen(instance.trigger);
        }
      });
    }

    // 搜尋燈箱
    const searchTrigger = document.querySelector('.search-lightbox');
    const searchContent = document.querySelector('#search-modal .search-modal-container');
    if (searchTrigger && searchContent) {
      searchTrigger.addEventListener('click', () => {
        GLightbox({
          elements: [{ content: searchContent }],
        }).open();
      });
    }

    // 靜態內容的燈箱初始化
    const staticLightboxes = [
      '.avatars-lightbox',
      '.shipping-policy-lightbox',
      '.return-exchange-policy-lightbox',
      '.privacy-policy-lightbox',
      '.register-privacy-policy-lightbox',
      '.termsOfService-lightbox',
      '.member-tier-lightbox'
    ];
    staticLightboxes.forEach(selector => initLightbox(selector));

    // 動態內容：訂單查詢
    initLightbox('.glightbox-order', (trigger) => {
      const orderId = trigger?.getAttribute('data-order-id');
      if (!orderId) return;

      const container = document.querySelector('#order-details-modal .order-details-container');
      if (container) {
        container.innerHTML = generateOrderDetails(orderId);
      }
    });

    // 動態內容：訊息總覽
    initLightbox('.glightbox-note', (trigger) => {
      const orderId = trigger?.getAttribute('data-order-id');
      if (!orderId) return;

      const container = document.querySelector('#note-details-modal .note-details-container');
      if (container) {
        container.innerHTML = generateOrderDetails(orderId);
      }
    });
  })();


  // ==================
  // 會員專區 - 通知總覽
  // 全選、刪除按鈕功能
  // ==================

  (function initCheckableTable({
    checkAllSelector = '#check-all',
    checkboxSelector = '.note-check-input',
    deleteBtnSelector = '#delete-btn',
    rowSelector = 'tr',
  } = {}) {
    const checkAll = document.querySelector(checkAllSelector);
    const checkboxes = document.querySelectorAll(checkboxSelector);
    const deleteBtn = document.querySelector(deleteBtnSelector);

    if (!checkAll || !deleteBtn || checkboxes.length === 0) {
      console.warn('[initCheckableTable] 不存在，未初始化。');
      return;
    }

    // 更新刪除按鈕顯示與全選狀態
    const updateUIState = () => {
      const checkedBoxes = [...checkboxes].filter(cb => cb.checked);
      deleteBtn.style.display = checkedBoxes.length > 0 ? 'inline-block' : 'none';
      checkAll.checked = checkedBoxes.length === checkboxes.length;
    };

    // 全選 checkbox 行為
    checkAll.addEventListener('change', () => {
      const checked = checkAll.checked;
      checkboxes.forEach(cb => (cb.checked = checked));
      updateUIState();
    });

    // 個別 checkbox 行為
    checkboxes.forEach(cb => {
      cb.addEventListener('change', updateUIState);
    });

    // 刪除已勾選列
    deleteBtn.addEventListener('click', () => {
      checkboxes.forEach(cb => {
        if (cb.checked) {
          cb.closest(rowSelector)?.remove();
        }
      });
      checkAll.checked = false;
      updateUIState();
    });
  })();
  

  // ==================
  // 結帳頁
  // 全選、子選單全選功能
  // ==================

  (function () {
    const allProductCheck = document.getElementById('allProduct-check');
    const cashAllCheck = document.getElementById('cashAll-check');
    const pointAllCheck = document.getElementById('pointAll-check');

    const allProductCheckboxes = document.querySelectorAll('.product-checkbox');
    const cashCheckboxes = document.querySelectorAll('.product-checkbox.cash');
    const pointCheckboxes = document.querySelectorAll('.product-checkbox.point');

    if (!allProductCheck || !cashAllCheck || !pointAllCheck || allProductCheckboxes.length === 0) {
      console.warn('[ProductCheckboxModule] 不存在，未初始化。');
      return;
    }

    // 判斷 checkbox 是否位於 disabled row 中
    const isInDisabledRow = cb => cb.closest('tr')?.classList.contains('disabled-row');

    // 批量勾選 checkbox（排除 disabled row）
    const toggleCheckboxes = (checkboxes, checked) => {
      checkboxes.forEach(cb => {
        if (!isInDisabledRow(cb)) {
          cb.checked = checked;
        }
      });
    };

    // 同步分類全選（現金、點數）
    const syncCategoryCheckboxes = () => {
      const activeCash = [...cashCheckboxes].filter(cb => !isInDisabledRow(cb));
      cashAllCheck.checked = activeCash.length > 0 && activeCash.every(cb => cb.checked);

      const activePoint = [...pointCheckboxes].filter(cb => !isInDisabledRow(cb));
      pointAllCheck.checked = activePoint.length > 0 && activePoint.every(cb => cb.checked);
    };

    // 同步總全選
    const syncAllProductCheckbox = () => {
      const activeAll = [...allProductCheckboxes].filter(cb => !isInDisabledRow(cb));
      allProductCheck.checked = activeAll.length > 0 && activeAll.every(cb => cb.checked);
    };

    // 綁定全選（總）
    allProductCheck.addEventListener('change', () => {
      toggleCheckboxes(allProductCheckboxes, allProductCheck.checked);
      syncCategoryCheckboxes();
    });

    // 綁定分類全選
    cashAllCheck.addEventListener('change', () => {
      toggleCheckboxes(cashCheckboxes, cashAllCheck.checked);
      syncAllProductCheckbox();
    });

    pointAllCheck.addEventListener('change', () => {
      toggleCheckboxes(pointCheckboxes, pointAllCheck.checked);
      syncAllProductCheckbox();
    });

    // 單一 checkbox 變化時同步全選狀態
    allProductCheckboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        syncCategoryCheckboxes();
        syncAllProductCheckbox();
      });
    });
  })();


  // ==================
  // 結帳頁
  // 移除按鈕功能
  // ==================

   (() => {
     const removeLinks = document.querySelectorAll('td[data-label="移除"] a');
     if (removeLinks.length === 0) return;

     removeLinks.forEach(link => {
       link.addEventListener('click', event => {
         event.preventDefault();
         const row = link.closest('tr');
         if (row) {
           row.remove();
         }
       });
     });
   })();


  // ==================
  // 會員專區
  // 大頭貼 上傳、裁切
  // ==================

  /* 
  const avatarInput = document.getElementById('avatarInput');
  const avatarPreview = document.getElementById('avatarPreview');
  const cropperImage = document.getElementById('cropperImage');
  const cropperModalEl = document.getElementById('cropperModal');
  const cropConfirmBtn = document.getElementById('cropConfirmBtn');

  // 如果沒有大頭貼圖片就中止
  if (!avatarPreview) return;

  const cropperModal = new bootstrap.Modal(cropperModalEl);
  let cropper;

  // 點擊頭像觸發檔案選擇器
  avatarPreview.addEventListener('click', () => {
    avatarInput.click();
  });

  // 選擇圖片後顯示裁切介面
  avatarInput.addEventListener('change', () => {
    const file = avatarInput.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        cropperImage.onload = () => {
          cropperModal.show(); // ✅ 等圖片載入完成再打開 modal
        };
        cropperImage.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  });

  // Modal 顯示時初始化 Cropper
  cropperModalEl.addEventListener('shown.bs.modal', () => {
    if (cropper) cropper.destroy();
    cropper = new Cropper(cropperImage, {
      aspectRatio: 1,
      viewMode: 2,
      responsive: true,
      autoCropArea: 1,
      movable: true,
      zoomable: true,
      scalable: false,
    });
  });

  // Modal 關閉時銷毀 Cropper
  cropperModalEl.addEventListener('hidden.bs.modal', () => {
    if (cropper) {
      cropper.destroy();
      cropper = null;
    }
    cropperImage.src = '';
    avatarInput.value = '';
  });

  // 確定裁切 → 更新大頭貼
  cropConfirmBtn.addEventListener('click', () => {
    if (cropper) {
      const canvas = cropper.getCroppedCanvas({
        width: 80,
        height: 80,
      });

      if (canvas) {
        avatarPreview.src = canvas.toDataURL('image/png');
        cropperModal.hide();
      } else {
        alert("裁切失敗，請再試一次");
      }
    }
  });
  */
 

  // ==================
  // 會員專區
  // 已複製連結 Toast已複製連結 Toast
  // ==================

  const copyInputs = document.querySelectorAll('.copy-input');
    
    if (copyInputs.length === 0) {
      return; // 沒有 .copy-input，結束
    }

    // 只有存在時才初始化 Toast
    const toastEl = document.getElementById('copyToast');
    const toast = new bootstrap.Toast(toastEl);

    copyInputs.forEach(input => {
      input.addEventListener('click', function () {
        this.select();
        this.setSelectionRange(0, 99999); // for mobile

        navigator.clipboard.writeText(this.value).then(() => {
          toast.show(); // 顯示 Toast 提示
        });
      });
    });


  
});


// =====================
// Navbar Brand 縮小效果
// =====================

let ticking = false;
window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const brand = document.querySelector('.navbar-brand');
      if (brand) brand.classList.toggle('scrolled', window.scrollY > 50);
      ticking = false;
    });
    ticking = true;
  }
}, { passive: true });



